module.exports = __webpack_public_path__ + "static/media/barcode-scanner.b6651494.svg";